module.exports = __webpack_public_path__ + "static/media/HSP70_heatmap.b85cdaa0.png";